/*!
 * orderStepOne.js
 * @module OrderStepOne
 *
 * @author Andrew Hill
 */
const Order = require('ORDER/Order');
const Utils = require('ORDER/Utils');
require('qtip2');
require('jquery-validation');
require('jquery.growl');
var cookie = require('lib/cookie');

$(function(){
    var Validator = $("#form_ordering_1").validate({
        onfocusout: function(){ return true; },
        rules: {
            qty_50ft: {
                min: {
                    param: 1,
                    depends: function(element){
                        var valid = true;
                        //check all reels elements
                        $('[data-calc="reels"]').each(function(){
                            if($(this).val() > 0){
                                valid = false;
                            }
                        });

                        return valid;
                    }
                }
            }
        },
        errorPlacement: function(error, element){
            error.addClass("errorWrapper");
            error.css("position", "absolute");

            if(element.attr('name').indexOf('qty_') !== false){
                error.css("left",  0);
                error.css("top", -40);
            } else {
                error.css("left", element.offset().left + element.width() + 10);
                error.css("top", element.offset().top - 4);
            }

            error.appendTo( element.parent() );
        },
        submitHandler: function(form) {
            Order.updateReelCost();
            form.submit();
        }
    });

    $('[data-qtip]').qtip({ // Grab all elements with a data-qtip attr.
        content: {
            attr: 'data-qtip-content' // Tell qTip2 to look inside this attr for its content
        },
        style: {
            classes: 'qtip-dark qtip-shadow qtip-rounded'
        }
    });

    $("[data-calc='reels']").change(function(){
        Order.updateReelCost();
        Validator.form();
    });

    $("[data-calc='transfer_to']").change(function(){
        Order.updateTransferToCost();
    });

    $("[data-calc='titles']").change(function(){
        Order.updateTitleCost();
    });

    $("[data-calc='musics']").change(function(){
        Order.updateMusicCost();
    });

    $("[data-calc='nocopies']").click(function(){
        Order.noCopies();
        return false;
    });

    $("[data-calc='copies']").change(function(e){
        Order.updateCopiesCost(e);
    });

    $("[data-calc='discount']").click(function(){
        Order.updateDiscountCost();
    });

    $('[data-increment]').click(function(){
        elementId = $(this).data('increment-id');
        incrementValue = parseInt($(this).data('increment-value'));

        Utils.increment(incrementValue, document.getElementById(elementId));
        $('#' + elementId).trigger('change');
    });

    $("button[type=submit]").click(function(){
        $("#form_ordering_1").attr("action", $(this).data("action"));
    });

    $.validator.addMethod("minOneOf", function(value, element){
        this.minOneOfValues = [];
        this.minOneOfValues.push(value);
        return true;
    });
});